import React from 'react'
import { makeStyles, Grid, Typography, Chip, Link } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#211A29',
    padding: '80px 20px',
    margin: 'auto',
    [theme.breakpoints.up('sm')]: {
      padding: '80px 120px',
    },
  },
  header: {
    color: 'white',
    margin: '1rem 0',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '52px',
    },
  },
  chip: {
    background: 'rgba(11, 11, 11, 0.8)',
    color: 'white',
  },
  link: {
    color: 'white',
    fontSize: '.8rem',
    padding: '.4rem 0',
    borderBottom: '1px solid white',
  },
  contentSection: {
    margin: '1rem 0',
    '& p': {
      color: 'white',
    },
  },
  contentCard: {
    padding: '1rem',
    background: 'rgba(255, 255, 255, 0.06)',
    borderRadius: '.4rem',
  },
  cardBody: {
    fontSize: '1rem',
  },
  cardHeader: {
    margin: '0 0 1rem 0',
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
}))

export default function ExchangeGuide(): JSX.Element {
  const classes = useStyles({})
  return (
    <div className={classes.root}>
      <Chip label="Exchange guide" className={classes.chip} />
      <Typography variant="h1" className={classes.header}>
        How to choose the right peer to peer exchange
      </Typography>
      <Link className={classes.link} underline="none">
        See the whole guide
      </Link>
      <div>
        <Grid container className={classes.contentSection} spacing={2} wrap="wrap">
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Platform activity
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Peer-to-peer exchanges without significant volumes and activity are inconvenient
                because it takes a lot of time to find the right offer. Look for one that has a lot
                of users or sellers in the region you’re interested in.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Payment methods
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                Some peer-to-peer exchanges allow for payment methods like cash and in-person
                meetups, gift cards and other exotic methods, others prefer to exclude them.
                Depending on what you’re after, look for the right one.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Security
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                A good exchange has processes in place to prevent fraud on its platform. For
                example, to prevent gift card fraud the marketplace has tools to check the validity
                of the gift card code. Moreover, a reputation system for sellers is important.
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.contentCard}>
              <Typography variant="body2" className={classes.cardHeader}>
                Privacy
              </Typography>
              <Typography variant="body2" className={classes.cardBody}>
                One of the main advantages of a peer-to-peer exchange is that you can find a seller
                without having to disclose your identity to the exchange platform. It’s peer-to-peer
                as the name says. However, it can be difficult to find a seller that sells to
                unverified users.
              </Typography>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
